import { render, staticRenderFns } from "./ManagePerson.vue?vue&type=template&id=a068c0da&scoped=true"
import script from "./ManagePerson.vue?vue&type=script&lang=js"
export * from "./ManagePerson.vue?vue&type=script&lang=js"
import style0 from "./ManagePerson.vue?vue&type=style&index=0&id=a068c0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a068c0da",
  null
  
)

export default component.exports